import React from "react";
import { graphql, useFragment } from "react-relay";

import { faFileExport } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";

import { isTeams } from "~/lib/utils";
import Menu from "~/ui/menu";

import ExportToDocsMenuItem from "./ExportToDocs";

import type { ExportMenuItem_note$key } from "~/__generated__/ExportMenuItem_note.graphql";
import type { ExportMenuItem_viewer$key } from "~/__generated__/ExportMenuItem_viewer.graphql";

const viewerFragment = graphql`
	fragment ExportMenuItem_viewer on Viewer {
		integrations {
			google {
				isActive
			}
		}
		user {
			isGuest
		}
		...ExportToDocs_viewer
	}
`;

const noteFragment = graphql`
	fragment ExportMenuItem_note on Note {
		stream {
			...ExportToDocs_stream
		}
	}
`;

export default function ExportMenuItem({
	note: noteKey,
	viewer: viewerKey,
}: {
	note: ExportMenuItem_note$key;
	viewer: ExportMenuItem_viewer$key;
}) {
	const viewer = useFragment(viewerFragment, viewerKey);
	const note = useFragment(noteFragment, noteKey);

	const canExportToDocs = !isTeams && Boolean(viewer.integrations.google?.isActive || viewer.user.isGuest);

	if (!canExportToDocs) return null;

	return (
		<Menu.Sub mobileHeaderTitle="Export…">
			<Menu.SubTrigger icon={faFileExport}>Export…</Menu.SubTrigger>
			<Menu.SubContent>
				{canExportToDocs && <ExportToDocsMenuItem viewer={viewer} stream={note.stream} />}
				{/* TODO: Other integrations? ask product/design */}
			</Menu.SubContent>
		</Menu.Sub>
	);
}
